// extracted by mini-css-extract-plugin
export default {"searchListingsPanel":"SectionSearchResults_searchListingsPanel__fgxzd","searchResultSummary":"SectionSearchResults_searchResultSummary__fv2gh"};